import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import eventImgPreview from './components/event_img_preview';

/**
 * @file
 * pagelayout.js
 */
(function ($, Drupal, drupalSettings, once) {
  'use strict';
  Drupal.behaviors.pageLayoutPatrimoine = {
    attach: function (context) {
      once('bind-main', 'body', context).forEach(el => {

        // TODO Main menu collapse
        const mainNavigation = document.getElementById('main-navigation');
        const toggler = document.querySelector('.navbar-toggler');

        if (mainNavigation) {
          mainNavigation.addEventListener('show.bs.collapse', event => {
            document.body.classList.add('overflow-hidden');
          });

          mainNavigation.addEventListener('hide.bs.collapse', event => {
            document.body.classList.remove('overflow-hidden');
          });
        }

        window.onresize = () => {
          if (toggler) {
            toggler.getAttribute('aria-expanded') === 'true' && toggler.click();
          }
        };

        // TODO Select Filter
        const selectFunction = function (element) {
          const $this = element;
          $this.select2({
            dropdownParent: $this.parents('.media-territory--filter'),
            minimumResultsForSearch: -1,
          });

          if ($(window).width() <= 755) {
            const $title = $this.prev('label').text();
            const data = $this.data('select2');
            data.$results.parents('.select2-results')
              .prepend(`<h2 class="select2-title">${$title}</h2>`)
              .append('<button class="select2-close" type="button"><span class="visually-hidden">Fermer</span><span class="patricon patricon-close" aria-hidden="true"></span></button>')
              .on('click touchstart', function (e) {
                if (!$(e.target).is('.select2-results__option')) {
                  e.preventDefault();
                  $this.select2('close');
                }
              });

            $this.on('select2:open', function (e) {
              setTimeout(function () {
                $this.closest('.select-wrapper').addClass('opened');
              }, 500);
            });

            $this.on('select2:close', function (e) {
              $this.closest('.select-wrapper').removeClass('opened');
            });
          }
        };

        const filterFormSelect = $('.form-select', '.media-territory--filter');

        if (filterFormSelect) {
          filterFormSelect.each(function () {
            const element = $(this);
            selectFunction(element);

            $(window).on('resize', function () {
              selectFunction(element);
            });
          });

          $(document).on('change', filterFormSelect, function () {
            setTimeout(function () {
              $('.form-select', '.media-territory--filter').each(function () {
                const element = $(this);
                selectFunction(element);
              });
            }, 1000);
          });
        }

        // TODO Evenement image preview
        eventImgPreview.init();

        //TODO Button to top
        const btnToTop = document.querySelector('.btn-to-top');
        window.addEventListener('scroll', () => {
          if (window.scrollY >= 3000) {
            btnToTop.classList.remove('d-none');
          } else {
            if (!btnToTop.classList.contains('d-none')) {
              btnToTop.classList.add('d-none');
            }
          }
        });

      });
    },
    detach: function (context, drupalSettings) {},
  };
}(jQuery, Drupal, drupalSettings, once));
